import { Get, getAPIUrl, Post } from "../../../ApiServices/apiMethod";

export const Recharge2Endpoint = {
    getBbps2Services:"Api/V1/Bbps2/getBbps2Services",
  getOperator: "Api/V1/Bbps2/getOperators",
  getOperatorbyOpCode: "Api/V1/Bbps2/getOperatorbyOpCode",
  fetchBill: "Api/V1/Bbps2/fetchBill",
  bbps2BillPayment: "Api/V1/Bbps2/bbps2BillPayment",
  checkBbps2Status: "Api/V1/Bbps2/checkBbps2Status",
  bbps2Report:"Api/V1/Bbps2/bbps2Report"
};
export const getBbps2Services = (param = "") => {
    const url = getAPIUrl(Recharge2Endpoint.getBbps2Services, param);
    return Get(url);
  };
export const bbps2getOperator = (data,param = "") => {
  const url = getAPIUrl(Recharge2Endpoint.getOperator, param);
  return Post(url,data);
};

export const bbps2getOperatorbyOpCode = (data, param = "") => {
  const url = getAPIUrl(Recharge2Endpoint.getOperatorbyOpCode, param);
  return Post(url, data);
};
export const bbps2fetchBill = (data, param = "") => {
  const url = getAPIUrl(Recharge2Endpoint.fetchBill, param);
  return Post(url, data);
};
export const bbps2BillPayment = (data, param = "") => {
    const url = getAPIUrl(Recharge2Endpoint.bbps2BillPayment, param);
  return Post(url, data);
};
export const checkBbps2Status = (data, param = "") => {
  const url = getAPIUrl(Recharge2Endpoint.checkBbps2Status, param);
  return Post(url, data);
};


export const getBbps2Report = (data, param = "") => {
    const url = getAPIUrl(Recharge2Endpoint.bbps2Report, param);
    return Post(url, data);
  };